import React, { useMemo, useState } from "react";
import { Card, Progress, Typography } from "antd";
import "../styles/quiz.css";
import StepObjective from "../components/StepObjective";
import StepPrescription from "../components/StepPrescription";
import StepInterest from "../components/StepInterest";
import StepLead from "../components/StepLead";

const { Title } = Typography;

const PHONE_BY_UNIT = {
  tatuape: "5511939422820",
  ipiranga: "5511956670040",
};

function pushDL(event, payload = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
}

function humanObjective(v) {
  const map = {
    leitura: "Leitura",
    computador: "Trabalhar em frente ao computador",
    presbiopia: "Corrigir presbiopia (perto e longe)",
    orientacao: "Não sei, preciso de orientação",
  };
  return map[v] || "—";
}

function humanPrescription(v) {
  const map = {
    sim: "✅ Sim (tenho receita em mãos)",
    nao: "❌ Não tenho receita",
  };
  return map[v] || "—";
}

function humanInterest(v) {
  const map = {
    armacao: "Comprar armação nova",
    lentes: "Comprar lentes novas",
    oculos_completos: "Ver promoções de óculos completos",
  };
  return map[v] || "—";
}

function humanUnit(v) {
  const map = { tatuape: "Tatuapé", ipiranga: "Ipiranga" };
  return map[v] || "—";
}

function buildWhatsAppText(a) {
  const nome = (a?.name || "").trim() || "Cliente";
  const cupom = a?.coupon || "PRIMEIRACOMPRA";

  return [
    `Olá! Me chamo *${nome}* e fiz o quiz da *Óticas Bluevision* 😊`,
    ``,
    `*Resumo do atendimento:*`,
    `• Objetivo: *${humanObjective(a?.objective)}*`,
    `• Receita: *${humanPrescription(a?.hasPrescription)}*`,
    `• Interesse: *${humanInterest(a?.interest)}*`,
    `• Unidade: *${humanUnit(a?.unit)}*`,
    ``,
    `*Cupom:* ${cupom}`,
  ].join("\n");
}

function buildWaLink(a) {
  const unit = a?.unit || "tatuape";
  const phone = PHONE_BY_UNIT[unit] || PHONE_BY_UNIT.tatuape;
  const text = buildWhatsAppText(a);
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}

export default function Quiz() {
  const [step, setStep] = useState(0);

  const [answers, setAnswers] = useState({
    objective: null,
    hasPrescription: null,
    interest: null,
    name: "",
    unit: null,
    coupon: "PRIMEIRACOMPRA",
  });

  const goNext = () => setStep((s) => Math.min(s + 1, 3));
  const goBack = () => setStep((s) => Math.max(s - 1, 0));

  const steps = useMemo(
    () => [
      {
        title: "Qual o seu objetivo com os óculos?",
        content: (
          <StepObjective
            value={answers.objective}
            onPick={(v) => {
              setAnswers((p) => ({ ...p, objective: v }));
              goNext();
            }}
          />
        ),
      },
      {
        title: "Você já tem uma receita atualizada?",
        content: (
          <StepPrescription
            value={answers.hasPrescription}
            onPick={(v) => {
              setAnswers((p) => ({ ...p, hasPrescription: v }));
              goNext();
            }}
            onBack={goBack}
          />
        ),
      },
      {
        title: "Qual seu maior interesse agora?",
        content: (
          <StepInterest
            value={answers.interest}
            onPick={(v) => {
              setAnswers((p) => ({ ...p, interest: v }));
              goNext();
            }}
            onBack={goBack}
          />
        ),
      },
      {
        title: "Próximos passos",
        content: (
          <StepLead
            answers={answers}
            setAnswers={setAnswers}
            onBack={goBack}
            onFinish={(finalAnswers) => {
              // ✅ 1) evento no GTM (sem PII)
              pushDL("bv_whatsapp_click", {
                unit: finalAnswers.unit || "tatuape",
                objective: finalAnswers.objective || null,
                hasPrescription: finalAnswers.hasPrescription || null,
                interest: finalAnswers.interest || null,
                coupon: finalAnswers.coupon || "PRIMEIRACOMPRA",
              });

              // ✅ 2) vai direto pro WhatsApp
              const waUrl = buildWaLink(finalAnswers);
              window.location.assign(waUrl);
            }}
          />
        ),
      },
    ],
    [answers]
  );

  const percent = Math.round(((step + 1) / steps.length) * 100);

  return (
    <div className="bv-page">
      <div className="bv-progress-wrap">
        <Progress
          percent={percent}
          showInfo={false}
          strokeColor="#F6C400"
          trailColor="rgba(255,255,255,0.25)"
        />
      </div>

      <div className="bv-container">
        <div className="bv-hero-image">
          <img
            src={process.env.PUBLIC_URL + "/homem.png"}
            alt="Óticas Bluevision"
            className="bv-hero-img"
          />
        </div>

        <Card className="bv-card" bordered={false}>
          <Title level={2} className="bv-title">
            {steps[step].title}
          </Title>

          {steps[step].content}

          <div className="bv-footer">
            <a href="/privacidade">Política de Privacidade</a>
          </div>
        </Card>
      </div>
    </div>
  );
}